import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const home = {
  global,
  path: paths.home,
  pathname: pathnames[paths.home],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
    ]
  }
};
